import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      sound: null, // init by soundManager
    };
  },
  computed: {
    ...mapGetters({
      playStatus: 'productRecommendationAudio/playStatus', // manage playStatus in store due we limit play 1 sound
      currentSound: 'productRecommendationAudio/currentSound',
      currentSoundId: 'productRecommendationAudio/currentSoundId',
    }),
    isPlaying() {
      if (this.isCurrentElement) {
        return this.playStatus === 'playing' ? true : false;
      }
      return false;
    },
  },
  watch: {
    'element.id'() {
      // console.log('element id changed: ', this.element.id);
      this.doAudioPlayerClean();
    },
  },
  methods: {
    clickAudioPlayButton(element) {
      if (this.isCurrentElement) {
        switch (this.playStatus) {
          case 'playing':
            this.doAudioPlayerPause();
            break;
          case 'paused':
            this.doAudioPlayerResume();
            break;
          default:
            this.doAudioPlayerSetup();
            break;
        }
      } else {
        this.doAudioPlayerSetup(element);
      }
    },
    doAudioPlayerSetup(element) {
      this.doAudioPlayerStopAll();
      this.$store.dispatch('productRecommendationAudio/setCurrentSound', element);

      const audioUrl = element.previews.mp3.url;

      console.log('[recommendationAudioPlayer.mixin] doAudioPlayer SETUP: ', element.id, this.sound, audioUrl);

      if (this.sound === null) {
        this.sound = this.$audioPlayer.player.createSound({
          id: element.id,
          url: audioUrl,
        });
      }

      this.sound.play({
        url: audioUrl,
      });

      this.$store.dispatch('productRecommendationAudio/setPlayStatus', 'playing');
    },
    doAudioPlayerStopAll() {
      console.log('[recommendationAudioPlayer.mixin] doAudioPlayer STOP ALL');
      this.$audioPlayer.stopAll();
    },
    doAudioPlayerStop() {
      console.log('[recommendationAudioPlayer.mixin] doAudioPlayer STOP');
      // this.$audioPlayer.stopAll();
      this.sound.stop();
      this.$store.dispatch('productRecommendationAudio/setPlayStatus', '');
    },
    doAudioPlayerPause() {
      console.log('[recommendationAudioPlayer.mixin] doAudioPlayer PAUSE');
      this.sound.pause();
      this.$store.dispatch('productRecommendationAudio/setPlayStatus', 'paused');
    },
    doAudioPlayerResume() {
      console.log('[recommendationAudioPlayer.mixin] doAudioPlayer RESUME');
      // this.$audioPlayer.resumeAll();
      this.sound.resume();
      this.$store.dispatch('productRecommendationAudio/setPlayStatus', 'playing');
    },
    doAudioPlayerReset() {
      // console.log('[recommendationAudioPlayer.mixin] doAudioPlayer RESET: ');
      if (this.sound !== null) {
        this.sound.destruct(); // soundManger API
        this.sound = null;
      }
      this.$store.dispatch('productRecommendationAudio/reset');
    },
    doAudioPlayerClean() {
      console.log('doAudioPlayerClean');
      if (this.sound !== null) {
        this.doAudioPlayerStop();
        this.doAudioPlayerReset();
      }
    },
  },
  beforeDestroy() {
    this.doAudioPlayerClean();
  },
};
